// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"211":"e10a2163","453":"e301017e","484":"5a5d2965","766":"117ba98d","826":"afa901c7"}[chunkId] + ".chunk.js";
};